import moment from 'moment';
import { Link } from 'react-router-dom';
import { Box, Button, Flex, Grid } from 'theme-ui';
import { DATE_FORMAT } from 'app/constants';
import { Markdown } from '../Markdown';
import PlusMinusIcon from '~/ContentBlocks/FAQ/PlusMinusIcon';
import { useState } from 'react';

export const AnnouncementRow = ({ announcement, sx, ...props }) =>
    { 
        const [isExpanded, setIsExpanded] = useState(false);
        return (
            <Grid
                sx={{
                    gridTemplateColumns: 'auto 12px',
                    gridGap: '12px',
                    py: 3,
                    borderBottom: '1px solid #D5D9DA',
                    color: '#00000A',
                    textDecoration: 'none',
                    '&::after': { display: 'none' },
                    ...sx
                }}
                {...props}
            >
                <Flex sx={{ flexDirection: 'column', gridGap: '5px' }}>
                    <Flex sx={{ flexDirection: 'row', justifyContent: 'space-between', gap: '20px' }}>
                        <Box
                            as={Link}
                            to={{pathname: announcement.announcement}}
                            target={'_blank'}
                            sx={{
                                textDecoration: 'none',
                            }}
                        >
                            <Box className="link-title">ASX: {announcement.label}</Box>
                            <Box sx={{ fontSize: '14px', color: '#6A7175', my: 1 }}>
                                {moment.utc(announcement.releaseDate).format(DATE_FORMAT.datetime_format_friendly)}
                            </Box>
                        </Box>

                        <Button
                            ml={1}
                            variant='announcement'
                            onClick={() => {setIsExpanded(!isExpanded)}}
                            sx={{ alignSelf: 'center' }}
                        >
                            <PlusMinusIcon isActive={isExpanded} />
                        </Button>
                    </Flex>
                    {announcement?.summary && (
                        <Box 
                            sx={{ display: 'block', fontSize: '14px', color: '#6A7175', maxHeight: isExpanded ? '500px' : '0px', overflow: 'hidden', transition: 'max-height 0.5s ease-in-out' }}>
                            {announcement?.summary?.map((sum, key) => (
                                <Markdown key={`summary${key}`}>
                                    {`- ${sum}`}
                                </Markdown>
                            ))} 
                        </Box>
                    )}
                </Flex>
            </Grid>
        )
    }